module.exports = __webpack_public_path__ + "img/cp4k.cfdbe348.png";